import { Tab } from 'bootstrap';
import $ from 'jquery';
import { qs, qsa } from '@/utils/dom';
export class PageHome {
    constructor() {
        const isHome = qs('body.template-home2025');
        if (!isHome)
            return;
        this.syncSelect2ToTabs();
        this.syncTabToSelect2();
    }
    syncSelect2ToTabs() {
        const $select2 = $('#news-events .form-select');
        ;
        $select2.on('select2:select', (event) => {
            const selectedSlug = $(event.target).val();
            const $tab = qs(`[data-bs-target="${selectedSlug}"]`);
            Tab.getOrCreateInstance($tab).show();
        });
    }
    syncTabToSelect2() {
        const $tabs = qsa('#news-events [role="tab"]');
        const $select2 = $('#news-events .form-select');
        $tabs.forEach((tab) => {
            tab.addEventListener('shown.bs.tab', (event) => {
                const target = event.target.getAttribute('data-bs-target');
                if (target) {
                    $select2.val(target).trigger('change');
                }
            });
        });
    }
}
